export const sortPerQuantity = 'display-per-quantity'
export const sortPerWeight = 'display-per-weight'
export const sortPerCode = 'display-per-code'
